export const { initialFormState } = {
    id: '',
    name: {
        az: '',
        en: '',
        ru: ''
    },
    servicepoint_ids: [],
    file_path_large: '',
    file_path_small: '',
    file_type: '',
    play_time: null,
    forward: '',
};